import messages from '@/locales'
import { useStore } from 'vuex'
import { computed } from 'vue'

/**
 * 获取翻译文本
 * @param {string} key - 翻译键，支持点号分隔的嵌套键
 * @param {Object} params - 替换参数
 * @returns {string} 翻译后的文本
 */
export function useTranslation() {
  const store = useStore()
  
  const currentLanguage = computed(() => store.getters['language/getCurrentLanguage'])
  
  const t = (key, params = {}) => {
    const keys = key.split('.')
    let value = messages[currentLanguage.value]
    
    for (const k of keys) {
      if (value && typeof value === 'object' && k in value) {
        value = value[k]
      } else {
        console.warn(`Translation key not found: ${key}`)
        return key
      }
    }
    
    if (typeof value !== 'string') {
      console.warn(`Translation value is not a string: ${key}`)
      return key
    }
    
    // 替换参数
    if (params && typeof params === 'object') {
      return value.replace(/\{(\w+)\}/g, (match, paramKey) => {
        return params[paramKey] !== undefined ? params[paramKey] : match
      })
    }
    
    return value
  }
  
  return {
    t,
    currentLanguage
  }
}

/**
 * 格式化日期
 * @param {number} timestamp - 时间戳
 * @param {string} locale - 语言环境
 * @returns {string} 格式化后的日期
 */
export function formatDate(timestamp, locale = 'zh-TW') {
  const date = new Date(parseInt(timestamp) * 1000)
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  
  if (locale === 'en') {
    return `${month}/${day}/${year}`
  }
  
  return `${year}.${month}.${day}`
}

/**
 * 格式化数字
 * @param {number} value - 数值
 * @param {string} locale - 语言环境
 * @returns {string} 格式化后的数字
 */
export function formatNumber(value, locale = 'zh-TW') {
  if (locale === 'en') {
    return value.toLocaleString('en-US')
  }
  
  return value.toLocaleString('zh-TW')
} 